import React from 'react'
import { getHexColor, TwoColorIconProps } from '../utils'

export const VideoCircleIcon: React.FC<TwoColorIconProps> = ({
  color1 = 'core-oxide',
  color2 = 'white',
  className,
  size = 16,
}) => {
  const c1 = getHexColor(color1)
  const c2 = getHexColor(color2)

  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={size} height={size} rx={size / 2} fill={c2} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.81525 5.5H4.46743C4.29927 5.5 4.13799 5.5625 4.01908 5.67375C3.90018 5.785 3.83337 5.93589 3.83337 6.09322V9.14407C3.83337 9.50368 3.98606 9.84857 4.25786 10.1029C4.52965 10.3571 4.89828 10.5 5.28265 10.5H9.63046C9.79862 10.5 9.9599 10.4375 10.0788 10.3263C10.1977 10.215 10.2645 10.0641 10.2645 9.90678V9.0926L11.6246 9.81973C11.7367 9.87968 11.8745 9.87925 11.9862 9.8186C12.0979 9.75795 12.1667 9.64625 12.1667 9.52541V6.47456C12.1667 6.35373 12.0979 6.24203 11.9862 6.18137C11.8745 6.12072 11.7367 6.12029 11.6246 6.18024L10.2645 6.90738V6.85593C10.2645 6.49632 10.1118 6.15143 9.84004 5.89714C9.56825 5.64286 9.19962 5.5 8.81525 5.5Z"
        fill={c1}
      />
    </svg>
  )
}
